import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    [theme.breakpoints.down('sm')]: {
      justifyContent: "flex-start",
    },
  },
  sortBox: {
    [theme.breakpoints.down('sm')]: {
      width: "80%",
    },
  },
  sortClass: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "22px",
    width: "100%",
    borderRadius: "4px",
  },
}));
